// Specification accordions under the add-to-cart button (Murano ceiling
// lamps). Facts come from the product description via src/lib/murano-specs.ts.

import { Gem, Plug, Ruler, ShieldCheck, type LucideIcon } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import type { SpecGroup } from "@/lib/murano-specs";

const ICONS: Record<string, LucideIcon> = {
  size: Ruler,
  glass: Gem,
  fitting: Plug,
  condition: ShieldCheck,
};

export function ProductSpecs({ groups, locale }: { groups: SpecGroup[]; locale: "da" | "en" }) {
  if (groups.length === 0) return null;
  return (
    <Accordion type="multiple" className="mt-10 border-t border-border">
      {groups.map((group) => {
        const Icon = ICONS[group.id] ?? Gem;
        return (
          <AccordionItem key={group.id} value={group.id} className="border-border">
            <AccordionTrigger className="font-body py-5 text-[11px] font-medium uppercase tracking-[0.22em] text-foreground hover:text-terracotta hover:no-underline">
              <span className="flex items-center gap-3">
                <Icon className="h-4 w-4 text-terracotta" strokeWidth={1.5} aria-hidden />
                {group.title[locale]}
              </span>
            </AccordionTrigger>
            <AccordionContent className="pb-5">
              <dl className="grid grid-cols-[minmax(7rem,auto)_1fr] gap-x-6 gap-y-2.5 pl-7 text-sm">
                {group.rows.map((row) => (
                  <div key={row.label.da} className="contents">
                    <dt className="text-muted-foreground">{row.label[locale]}</dt>
                    <dd className="text-foreground">{row.value[locale]}</dd>
                  </div>
                ))}
              </dl>
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
}
